<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <button type="button" id="btnLoadList" (click)="GetUserMasterList()" style="display:none">Get</button>
        <div class="divContainer" style="top:1px;">
          <div class="col-12 col-sm-12">
            <div class="card card-primary card-outline card-outline-tabs">
              <div class="card-body">
                <div>
                  <button type="button" id="btn_AddNew" (click)="PopupShow()" style="display:none">Add</button>

                  <table #dataTable class="display" style="width:100%"></table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button type="button" id="btnRemoveConfig" (click)="RemoveConfigConfirm()" style="display:none">Remove</button>

        <!--Add/Update Popup-->
        <div class="modal" id="myModal" [style.display]="showModal ? 'block' : 'none'">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">Productivity Config</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">&times;</button>
              </div>
              <div class="modal-body row">
                <div class="col-sm-2">
                  <div class="form-group">
                    <label for="ddlTaskName">Task Name</label>
                    <select id="ddlTaskName" class="form-control">
                      <option value=0>Select</option>
                      <option *ngFor="let item of TaskList" value={{item.Id}}>
                        {{item.TaskName}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label for="TxtRangeStart">Capacity Start</label>
                    <input type="number" id="TxtRangeStart" class="form-control" min="0" />
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label for="TxtRangeEnd">Capacity End</label>
                    <input type="number" id="TxtRangeEnd" class="form-control" min="0" />
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label for="TxtProductivity">Productivity %</label>
                    <input type="number" id="TxtProductivity" class="form-control" min="10" />
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label for="ddlRangeType">Range Type</label>
                    <select id="ddlRangeType" class="form-control">
                      <option value=Day>Day</option>
                      <option value=Month>Month</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-2">
                  <br />
                  <button type="button" class="btn btn-info waves-effect waves-light" data-dismiss="modal" (click)="ResetControls()">Reset</button>
                  <button type="submit" class="btn btn-success waves-effect waves-light" value="Update" (click)="UpdateConfig()">{{buttonTitle}}</button> &nbsp;
                </div>
                <div class="row fixTableHead" id="divBodyTable">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Task Name</th>
                        <th>Start Range</th>
                        <th>End Range</th>
                        <th>Productivity %</th>
                        <th>Range Type</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of UserPrdConfig;">
                        <td>
                          {{item.TaskName}}
                        </td>
                        <td>
                          {{item.CapacityStartRange}}
                        </td>
                        <td>
                          {{item.CapacityEndRange}}
                        </td>
                        <td>
                          {{item.Productivity}}
                        </td>
                        <td>
                          {{item.RangeType}}
                        </td>
                        <td>
                          <i class="fas fa-edit green-color" title="Modify" (click)="ModifyConfig(item)"></i>
                          &nbsp;
                          <i class="fas fa-trash orange-color" title="Remove" (click)="RemoveConfig(item)"></i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
              <div class="modal-footer">
              </div>
              <div id="LoadingImagePopup">
                <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
